export enum UserType {
  moral = 'moral',
  user = 'user'
}
